export default __webpack_public_path__ + "static/media/property_455.1cd5c299.png";